module.exports = __webpack_public_path__ + "img/valor.93411906.svg";